"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _constants = require("@seedlang/constants");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var PlayerTurn = (_class = /*#__PURE__*/function (_RootModel) {
  function PlayerTurn(parent) {
    var _this;
    _classCallCheck(this, PlayerTurn);
    _this = _callSuper(this, PlayerTurn);
    _initializerDefineProperty(_this, "parent", _descriptor, _this);
    _initializerDefineProperty(_this, "pastMultipleChoiceOptionId", _descriptor2, _this);
    _initializerDefineProperty(_this, "pastPoints", _descriptor3, _this);
    _initializerDefineProperty(_this, "pastPerformance", _descriptor4, _this);
    _initializerDefineProperty(_this, "timerStartedAt", _descriptor5, _this);
    _initializerDefineProperty(_this, "timerStoppedAt", _descriptor6, _this);
    _initializerDefineProperty(_this, "timerProgress", _descriptor7, _this);
    _initializerDefineProperty(_this, "correct", _descriptor8, _this);
    _this.parent = parent;
    return _this;
  }
  _inherits(PlayerTurn, _RootModel);
  return _createClass(PlayerTurn, [{
    key: "timerActive",
    get: function get() {
      return (0, _utils.isPresent)(this.timerStartedAt) && (0, _utils.isBlank)(this.timerStoppedAt);
    }
  }, {
    key: "secondsElapsed",
    get: function get() {
      if (this.timerStartedAt && this.timerStoppedAt && this.timerStartedAt > 0 && this.timerStoppedAt > 0) {
        return Math.floor((this.timerStoppedAt - this.timerStartedAt) / 1000);
      }
      return 0;
    }
  }, {
    key: "points",
    get: function get() {
      if (this.pastPoints && this.pastPoints > 0) {
        return this.pastPoints;
      }
      if (this.timerStoppedAt && this.correct) {
        return 20 - this.secondsElapsed;
      }
      return 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.pastPoints = 0;
      this.pastMultipleChoiceOptionId = null;
      this.timerStartedAt = null;
      this.timerStoppedAt = null;
      this.timerProgress = 0;
      this.correct = null;
    }
  }, {
    key: "initiateTimer",
    value: function initiateTimer(timerStartedAt) {
      this.timerStartedAt = timerStartedAt;
      this.timerProgress = 100;
    }
  }, {
    key: "stopTimer",
    value: function stopTimer(correct) {
      if (this.timerStartedAt && !this.timerStoppedAt) {
        this.timerStoppedAt = +new Date();
        if (correct !== null) {
          this.correct = correct;
        }
      }
    }
  }, {
    key: "updateTimerProgress",
    value: function updateTimerProgress() {
      if (this.timerActive) {
        var dateInt = +new Date();
        var timeDiff = (dateInt - this.timerStartedAt) / 1000;
        var opponentAnswers = this.pastPerformance && timeDiff - 1 > this.pastPerformance.secondsElapsed;
        if (opponentAnswers) {
          this.correct = false;
          this.stopTimer(this.pastPerformance.correct);
          this.pastPoints = this.pastPerformance.points;
          this.pastMultipleChoiceOptionId = this.pastPerformance.multipleChoiceOptionId;
          if (this.pastPerformance.correct) {
            this.parent.onCorrectOpponentTurn();
          } else {
            this.parent.onIncorrectOpponentTurn();
          }
        } else if (timeDiff > _constants.Constants.TRIVIA_TIMER_NUMBER_SECONDS) {
          this.stopTimer(false);
          if (this.me) {
            this.parent.timeOut();
          } else {
            this.parent.onIncorrectOpponentTurn();
          }
        }
      }
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "parent", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pastMultipleChoiceOptionId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pastPoints", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pastPerformance", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "timerStartedAt", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "timerStoppedAt", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "timerProgress", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "correct", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "timerActive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timerActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondsElapsed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondsElapsed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "points", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "points"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTimerProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateTimerProgress"), _class.prototype), _class);
var _default = exports["default"] = PlayerTurn;